export default __webpack_public_path__ + "img/person-new.11c87b32.svg";